/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React from 'react';

import BaseClass from '../base/LayoutBaseAuthoring';

const ExploreCardAuthoring = BaseClass.extend({

	init: function() {
		ExploreCardAuthoring.inherited('init', this, arguments);
	},

	add: function(widgetLayoutView) {
		this.consumeView.addChildRenderMarkup( widgetLayoutView.id, widgetLayoutView );
		this.consumeView.model.incrChildReadyCount();
	}
});

export default ExploreCardAuthoring;



// WEBPACK FOOTER //
// ./src/js/layout/explorecard/ExploreCardAuthoring.js